// TODO: move this into its own package structure (/lang/{language-code}.js, for each) and make it
// importable as a single structure
import Vue from 'vue'
import VueI18n from 'vue-i18n'

export const messages = {
  en: {
    buttons: {
      begin: 'Begin',
      previous: 'Previous',
      next: 'Next',
      submit: 'Submit',
      retry: 'Retry'
    },
    messages: {
      lastItemWarningTimed: 'You will not be able to advance to the next assessment or end the Assessment ' +
        'Session until the time limit is up. If you are finished you may click on the Previous button to ' +
        'review your answers.',
      lastItemWarningNonTimed: 'This is the last item in this section. You can click on the Previous button to ' +
        'review your answers. If you are ready, click on the Submit button. You will not be able to change ' + '' +
        'any of your responses after you click on the Submit button.',
      errors: {
        loadingFailed: 'Failed to load next page.',
        noConnection: 'You don\'t seem to have a working network connection.'
      }
    }
  },
  de: {
    buttons: {
      begin: 'Start',
      previous: 'Zurück',
      next: 'Weiter',
      submit: 'Senden',
      retry: 'Wiederholen'
    },
    messages: {
      lastItemWarningTimed: 'Sie können erst mit dem nächsten Test fortfahren oder die Testsitzung beenden, ' +
        'ab das Zeit abgelaufen ist. Ob Sie fertig sind, können Sie, auf die Schaltfläche Zurück klicken, ' +
        'um Ihre Antworten zu überprüfen.',
      lastItemWarningNonTimed: 'Dies ist der letzte Artikel. Sie können auf die Schaltfläche Zurück klicken, ' +
        'um Ihre Antworten zu überprüfen. Wenn Sie fertig sind, klicken Sie auf die Schaltfläche Senden. ' +
        'Sie können keine Ihrer Antworten ändern, nachdem Sie auf die Schaltfläche Senden geklickt haben.',
      errors: {
        loadingFailed: 'Versagen beim Laden der nächsten Seite.',
        noConnection: 'Vie scheinen keine funktionierende Netzwerkverbindung zu haben.'
      }
    }
  },
  fr: {
    buttons: {
      begin: 'Commencer',
      previous: 'Précédent',
      next: 'Suivant',
      submit: 'Soumettre',
      retry: 'Refaire'
    },
    messages: {
      lastItemWarningTimed: "Vous ne pourrez pas avancer à la prochaine évaluation ou mettre fin à la session d'évaluation tant que le délai n'a pas été écoulé. Si vous avez terminé, vous pouvez cliquer sur le bouton Précédent pour revoir vos réponses.",
      lastItemWarningNonTimed: "Vous ne pourrez pas avancer à la prochaine évaluation ou mettre fin à la session d'évaluation tant que le délai n'a pas été écoulé. Si vous avez terminé, vous pouvez cliquer sur le bouton Précédent pour revoir vos réponses.",
      errors: {
        loadingFailed: 'Raté de charger la page suivante.',
        noConnection: 'Vous ne semblez pas avoir une connexion réseau fonctionnelle.'
      }
    }
  },
  es: {
    buttons: {
      begin: 'Empezar',
      previous: 'Anterior',
      next: 'Siguiente',
      submit: 'Enviar',
      retry: 'Reintentar'
    },
    messages: {
      lastItemWarningTimed: 'No podrá avanzar a la próxima evaluación o finalizar la sesión de evaluación hasta que se agote el tiempo límite. Si ha terminado, puede hacer clic en el botón Anterior para revisar sus respuestas.',
      lastItemWarningNonTimed: 'Este es el último ítem. Puede hacer clic en el botón Anterior para revisar sus respuestas. Si está listo, haga clic en el botón Enviar. No podrá cambiar ninguna de sus respuestas después de hacer clic en el botón Enviar.',
      errors: {
        loadingFailed: 'Fallado al cargar la siguiente página.',
        noConnection: 'Parece que no tienes una conexión de red en funcionamiento.'
      }
    }
  },
  ja: {
    buttons: {
      begin: '開始',
      previous: '戻る',
      next: '次へ',
      submit: '送信',
      retry: '再試行'
    },
    messages: {
      lastItemWarningTimed: '制限時間が終わるまで、次のアセスメントに進んだり、アセスメント・セッションを終了したりはできません。終わったら、「戻る」ボタンをクリックして、回答を確認できます。',
      lastItemWarningNonTimed: 'これが最後の項目です。「戻る」ボタンをクリックして、回答を確認できます。確認できたら、「送信」ボタンをクリックしてください。「送信」ボタンをクリックした後は、回答は一切変更できなくなります。',
      errors: {
        loadingFailed: '次のページをロードできませんでした。',
        noConnection: 'ネットワークに接続されていないようです。'
      }
    }
  },
  'pt-BR': {
    buttons: {
      begin: 'Começar',
      previous: 'Anterior',
      next: 'Avançar',
      submit: 'Enviar',
      retry: 'Tentar novamente'
    },
    messages: {
      lastItemWarningTimed: 'Não será possível avançar para a próxima avaliação ou terminar a Sessão de ' +
        'Avaliação até que o limite de tempo tenha acabado. Se você tiver concluído, poderá clicar no botão ' +
        'Anterior para revisar suas respostas.',
      lastItemWarningNonTimed: 'Este é o último item. É possível clicar no botão Anterior para revisar suas ' +
        'respostas. Se estiver pronto, clique no botão Enviar. Você não poderá mudar suas respostas após ' +
        'clicar no botão Enviar.',
      errors: {
        loadingFailed: 'Falha ao carregar a próxima página.',
        noConnection: 'Você não parece ter uma conexão de rede funcional.'
      }
    }
  },
  ar: {
    buttons: {
      begin: 'بدء',
      previous: 'سابق',
      next: 'تالي',
      submit: 'إحالة',
      retry: 'إعادة المحاولة'
    },
    messages: {
      lastItemWarningTimed: 'لن يمكنك التقدم إلى التقييم التالي أو إنهاء جلسة التقييم حتى تنتهي المهلة الزمنية. إذا كان قد تم الانتهاء، يمكنك الضغط على الاختيار "سابق" لمراجعة إجاباتك.',
      lastItemWarningNonTimed: 'يعد هذا هو البند الأخير. يمكنك الضغط على الاختيار "سابق" لمراجعة إجاباتك. إذا كنت جاهزا، اضغط على الاختيار "إحالة". لن يمكنك تغيير أي من ردودك بعد الضغط على الاختيار "إحالة".',
      errors: {
        loadingFailed: 'فشل في تحميل الصفحة التالية.',
        noConnection: 'لا يبدو أنه يتوافر لديك وصلة شبكة اتصال تعمل.'
      }
    }
  },
  hi: {
    buttons: {
      begin: 'शुरू करें',
      previous: 'पीछे जाएं',
      next: 'आगे जाएं',
      submit: 'सबमिट करें',
      retry: 'फिर से कोशिश करें'
    },
    messages: {
      lastItemWarningTimed: 'समय सीमा खत्म होने से पहले आप अगले मूल्यांकन पर नहीं जा पाएंगे, न ही आप मूल्यांकन सत्र को खत्म कर पाएंगे। अगर आपने मूल्यांकन पूरा कर लिया है, तो अपने जवाब फिर से देखने के लिए आप \'पीछे जाएं\' बटन पर क्लिक कर सकते हैं',
      lastItemWarningNonTimed: 'यह आखिरी आइटम है। अपने जवाब फिर से देखने के लिए आप \'पीछे जाएं\' बटन पर क्लिक कर सकते हैं I अगर आप तैयार हैं, तो \'सबमिट करें\' बटन पर क्लिक करें। \'सबमिट करें\' बटन पर क्लिक करने के बाद, आप अपना कोई भी जवाब बदल नहीं पाएंगे I',
      errors: {
        loadingFailed: 'अगला पेज लोड नहीं हो सका I',
        noConnection: 'लग रहा है कि आपका इंटरनेट कनेक्शन काम नहीं कर रहा I'
      }
    }
  }
}

Vue.use(VueI18n)
const ASSESSMENT_LANGUAGE_KEY_TEMPLATE = 'assessment-{}.language'

const i18n = new VueI18n(
  {
    // Default locale. Will be overriden on application startup
    locale: 'en',
    fallbackLocale: 'en',
    messages
  }
)

export default i18n

export function configLangFromRouter (vue, router) {
  let language = router.currentRoute.query.language
  const storageKey = ASSESSMENT_LANGUAGE_KEY_TEMPLATE.format(router.currentRoute.params.id)

  if (language) {
    localStorage.setItem(storageKey, language)
  } else {
    console.debug(`Getting locale from localStorage[${storageKey}]`)
    language = localStorage.getItem(storageKey)
    if (!language) {
      console.debug('Couldn\'t determine language to use. Falling back to default')
      language = 'en'
    }
  }

  console.log('Setting locale to ' + language)
  vue.$i18n.locale = language
}

const RTL_LANGUAGES = ['ar']

// TODO: it's better to get it from the server, which we could do by fixing/improving the config above
export function getTextDirectionality (localeName) {
  return RTL_LANGUAGES.includes(localeName)
}
